import type {AbstractSketchEdgeObject} from '../sketch/AbstractSketchEdgeObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图抽象边对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图抽象边协议时返回 true。
 */
export function isAbstractSketchEdgeObject(value: unknown): value is AbstractSketchEdgeObject {
	// 使用运行时标记进行判定，避免对构造函数做强耦合判断。
	return hasRuntimeFlag(value, 'isAbstractSketchEdgeObject');
}
